import React from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { Tooltip } from 'antd'
import { Icon, Div, Button } from 'konsys-ui'
import { ChevronsUpDown } from 'lucide-react'
import {
  InputWithPlaceHolder, StatusSelector, HeaderLabel, CellText, RolesSelector,
} from '../../../components/user-components'
import { theme } from '../../../styles/_variables'
import { status, statusText } from '../constants'

const { color } = theme

export default {
  columns: [{
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          รหัสพนักงาน <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'userId',
    sortable: true,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => (
      <InputWithPlaceHolder
        handleChange={e => (_.isEmpty(e) ? onChange(e) : onChange(parseInt(e, 10)))}
      />
    ),
    filterMethod: (filter, row) => _.includes(row.id, filter.value),
    width: 90,
  }, {
    id: 'firstname',
    Header: () => <HeaderLabel>ชื่อ <ChevronsUpDown color={color.coolGrey} /></HeaderLabel>,
    accessor: 'firstname',
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.createdDate, filter.value),
    sortable: true,
    filterable: true,
    width: 150,
  }, {
    Header: () => <HeaderLabel>นามสกุล <ChevronsUpDown color={color.coolGrey} /></HeaderLabel>,
    accessor: 'lastname',
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.createdDate, filter.value),
    sortable: true,
    filterable: true,
    width: 150,
  }, {
    Header: () => <HeaderLabel>อีเมล</HeaderLabel>,
    accessor: 'email',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.clientId, filter.value),
    width: 200,
  }, {
    Header: <HeaderLabel>เบอร์โทรศัพท์</HeaderLabel>,
    accessor: 'telephone',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.clientName, filter.value),
    width: 140,
  }, {
    Header: <HeaderLabel>หน้าที่</HeaderLabel>,
    accessor: 'Roles',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value[0].description}</CellText>,
    Filter: ({ onChange }) => <RolesSelector handleChange={e => onChange(e)} statusAttr='ทั้งหมด' filter={true}/>,
    filterMethod: (filter, row) => _.includes(row.from, filter.value),
    width: 160,
  }, {
    Header: <HeaderLabel>สถานะ</HeaderLabel>,
    accessor: 'status',
    sortable: false,
    filterable: true,
    Cell: props => (
      <CellText

        color={props.value === status.ACTIVE ? color.success : color.error}
      >
        {props.value === status.ACTIVE ? statusText.ACTIVE : statusText.INACTIVE}
      </CellText>
    ),
    Filter: ({ onChange }) => <StatusSelector handleChange={e => onChange(e)} statusAttr='ทั้งหมด' filter={true}/>,
    filterMethod: (filter, row) => _.includes(row.to, filter.value),
    width: 140,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    // Cell: props => <ActionSelector disabled={props.tdProps.rest.disabled} />,
    Cell: props => <Link target="_blank" to={`/user/view/${props.original.userId}`}><Button small text='ดูรายละเอียด'/></Link>,
    width: 150,
  }],
}
